import { getBackendUrl } from '../config';

const backendUrl = getBackendUrl();

/**
 * Monta a URL da foto de perfil do usuário (mesma convenção usada em
 * UsersPresencePanel e no layout). Retorna `null` quando não há imagem —
 * nesse caso use o fallback de iniciais no <Avatar>.
 */
export const getUserAvatarUrl = (profileImage, companyId) => {
  if (!profileImage) return null;
  if (profileImage.startsWith('http')) return profileImage;
  return `${backendUrl}/public/company${companyId}/profile-images/${profileImage}`;
};

export default getUserAvatarUrl;
